export const INFINITE_SCROLL_OFFSET_DESKTOP = '-100px';
export const INFINITE_SCROLL_OFFSET_MOBILE = '-75px';
export const HIGHLIGHT_TEXT_ID = 'highlighted-text';
export const WORDS_BEFORE_MATCHING = 3;
